module.exports = __webpack_public_path__ + "img/paynow-logo.5ce53be4.png";